/* DV-DEALS-FILTERS-V3 — Canlı Fırsatlar filtre + sıralama
   Veri kaynağı: Shopify Search & Discovery facet formu (#hdt-facet-filters-form-sidebar).
   Tag URL YOK — gerçek facet query parametreleri (metafield tabanlı) kullanılır:
     Mekân = filter.p.m.custom.kullan_m_alanlar_
     Renk  = filter.p.m.custom.renk
     Ölçü  = filter.v.option.boyut (S&D gruplu değerler, GID)
     Tarz  = filter.p.m.custom.tarzlar
   Ana sayfa: bar "Canlı Fırsatlar" başlığının ALTINA yerleşir; seçim koleksiyona gider.
   Koleksiyon: "En çok indirim" tüm sayfaları (Section Rendering API) çekip global sıralar,
   load-more'u kapatır. Facet verisi yoksa grup çizilmez (fail-closed, uydurma değer yok). */
(() => {
  'use strict';

  const BASE = '/collections/firsat-algoritmasi';
  const SID_FALLBACK = window.Shopify &&
    String(window.Shopify.theme && window.Shopify.theme.id) === '162389819608'
      ? 'template--22699908563160__main'
      : 'template--22305147879640__main';
  const SORT_PARAM = 'dv_sort';
  const SORT_VALUE = 'discount';
  const MAX_PAGES = 25;
  const CACHE_KEY = 'dvdf3-facets';
  const CACHE_TTL = 600000; /* 10 dk */

  const GROUPS = [
    { key: 'Mekân', icon: '🏠', param: 'filter.p.m.custom.kullan_m_alanlar_' },
    { key: 'Renk',  icon: '🎨', param: 'filter.p.m.custom.renk' },
    { key: 'Ölçü',  icon: '📐', param: 'filter.v.option.boyut' },
    { key: 'Tarz',  icon: '✨', param: 'filter.p.m.custom.tarzlar' }
  ];

  const RENK_DOT = {
    'bej': '#d8c6a3', 'krem': '#f1e8d7', 'antrasit': '#3b3b3d', 'gri': '#a3a3a6',
    'mavi': '#4f6f9e', 'kırmızı': '#b2372f', 'siyah': '#17171a', 'kahve': '#6a4a33',
    'yeşil': '#4c7a4c', 'sarı': '#e0a93e', 'pembe': '#d089a0', 'mor': '#6d5a8e',
    'turuncu': '#d07b3a', 'multi': 'conic-gradient(#b2372f,#e0a93e,#4c7a4c,#4f6f9e,#b2372f)'
  };

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function getContext() {
    const sec = document.querySelector('[id*="dv_active_deals"]');
    if (sec) return { mode: 'index', section: sec };
    if (new RegExp('^' + BASE + '/?$').test(window.location.pathname)) return { mode: 'collection', section: null };
    return null;
  }

  function getSid() {
    const a = document.querySelector('.hdt-pagination-wrapp a[section-id]');
    if (a && a.getAttribute('section-id')) return a.getAttribute('section-id');
    const g = document.querySelector('[id^="products-template--"]');
    if (g) return g.id.replace(/^products-/, '');
    return SID_FALLBACK;
  }

  function findGrid() {
    const g = document.querySelector('[id^="products-template--"]');
    if (g) return g;
    const card = document.querySelector('hdt-card-product, .hdt-card-product');
    return card ? card.parentElement : null;
  }

  /* ---- facet verisini oku ---- */

  function parseForm(root) {
    const form = root.querySelector('#hdt-facet-filters-form-sidebar') || root.querySelector('form[id*="facet-filters"]');
    if (!form) return null;
    const out = [];
    GROUPS.forEach(cfg => {
      const inputs = form.querySelectorAll('input[name="' + cfg.param + '"]');
      if (!inputs.length) return;
      const items = [];
      inputs.forEach(inp => {
        const v = inp.value;
        if (!v) return;
        let txt = '';
        if (inp.id) {
          const lab = form.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(inp.id) : inp.id) + '"]');
          if (lab) txt = lab.textContent.replace(/\s+/g, ' ').trim();
        }
        const cm = /\((\d+)\)\s*$/.exec(txt);
        const count = cm ? parseInt(cm[1], 10) : null;
        let label;
        if (v.indexOf('gid://') === 0) {
          label = txt.replace(/\(\d+\)\s*$/, '').trim();
          if (!label) return; /* GID için görünen etiket yoksa çizme */
          label = label.replace(/\s*Metre\s*Kare/i, ' m²');
        } else {
          label = v;
        }
        items.push({ v: v, l: label, c: count });
      });
      if (items.length) out.push({ key: cfg.key, icon: cfg.icon, param: cfg.param, items: items });
    });
    return out.length ? out : null;
  }

  async function fetchGroups() {
    try {
      const c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.t && Date.now() - c.t < CACHE_TTL && Array.isArray(c.g) && c.g.length) return c.g;
    } catch (_) { /* yoksay */ }
    let doc = null;
    try {
      const r = await fetch(BASE + '?section_id=' + encodeURIComponent(SID_FALLBACK));
      if (r.ok) doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    } catch (_) { /* yoksay */ }
    let groups = doc ? parseForm(doc) : null;
    if (!groups) {
      try {
        const r2 = await fetch(BASE);
        if (r2.ok) {
          const d2 = new DOMParser().parseFromString(await r2.text(), 'text/html');
          groups = parseForm(d2);
        }
      } catch (_) { /* yoksay */ }
    }
    if (groups) {
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), g: groups })); } catch (_) { /* yoksay */ }
    }
    return groups || [];
  }

  async function loadGroups(ctx) {
    if (ctx.mode === 'collection') {
      const live = parseForm(document);
      if (live) return live;
    }
    return fetchGroups();
  }

  /* ---- URL kurucular ---- */

  function baseParams(ctx) {
    const q = ctx.mode === 'collection'
      ? new URLSearchParams(window.location.search)
      : new URLSearchParams();
    q.delete('page');
    q.delete('section_id');
    q.delete('preview_theme_id');
    q.delete('_ab');
    return q;
  }

  function hrefFor(ctx, param, value, isActive) {
    const q = baseParams(ctx);
    q.delete(param);
    if (!isActive) q.append(param, value);
    const s = q.toString();
    return BASE + (s ? '?' + s : '');
  }

  function hrefSort(ctx, sortActive) {
    const q = baseParams(ctx);
    if (sortActive) q.delete(SORT_PARAM);
    else q.set(SORT_PARAM, SORT_VALUE);
    const s = q.toString();
    return BASE + (s ? '?' + s : '');
  }

  /* ---- kart yüzdesi ---- */

  function percentOf(card) {
    const badge = card.querySelector('.dolcevita-discount-badge');
    if (!badge) return -1;
    const attr = parseInt(badge.getAttribute('data-percent') || '', 10);
    if (Number.isFinite(attr)) return attr;
    const m = /(\d+)\s*%/.exec(badge.textContent || '') || /%\s*(\d+)/.exec(badge.textContent || '');
    return m ? parseInt(m[1], 10) : -1;
  }

  function cardKey(card) {
    const a = card.querySelector('a[href*="/products/"]');
    return a ? (a.getAttribute('href') || '').split('?')[0].split('#')[0] : '';
  }

  /* ---- global "en çok indirim" sıralaması (koleksiyon) ---- */

  async function runGlobalSort(bar) {
    const grid = findGrid();
    if (!grid) return;
    const sortBtn = bar.querySelector('.dv-df-sort');
    const note = bar.querySelector('.dv-df-note');
    if (sortBtn) { sortBtn.classList.add('busy'); sortBtn.querySelector('u').textContent = 'Sıralanıyor…'; }

    const sid = getSid();
    const seen = new Set();
    grid.querySelectorAll('hdt-card-product, .hdt-card-product').forEach(c => { const k = cardKey(c); if (k) seen.add(k); });

    const lm = document.querySelector('.hdt-pagination-wrapp');
    if (lm) {
      const q = baseParams({ mode: 'collection' });
      q.delete(SORT_PARAM);
      let page = 2;
      let stop = false;
      while (!stop && page <= MAX_PAGES) {
        const batch = [];
        for (let i = 0; i < 4 && page <= MAX_PAGES; i++, page++) {
          const qq = new URLSearchParams(q);
          qq.set('page', String(page));
          qq.set('section_id', sid);
          batch.push(
            fetch(BASE + '?' + qq.toString())
              .then(r => (r.ok ? r.text() : null))
              .then(t => {
                if (!t) return null;
                const d = new DOMParser().parseFromString(t, 'text/html');
                return Array.from(d.querySelectorAll('hdt-card-product, .hdt-card-product'));
              })
              .catch(() => null)
          );
        }
        const results = await Promise.all(batch);
        for (const nodes of results) {
          if (!nodes || !nodes.length) { stop = true; break; }
          nodes.forEach(n => {
            const k = cardKey(n);
            if (k && seen.has(k)) return;
            if (k) seen.add(k);
            grid.appendChild(document.importNode(n, true));
          });
        }
      }
      lm.remove();
    }

    const cards = Array.from(grid.children).filter(c => c.matches('hdt-card-product, .hdt-card-product'));
    cards
      .map(c => [percentOf(c), c])
      .sort((a, b) => b[0] - a[0])
      .forEach(p => grid.appendChild(p[1]));

    if (sortBtn) { sortBtn.classList.remove('busy'); sortBtn.querySelector('u').textContent = 'En çok indirim'; }
    if (note && cards.length) {
      note.hidden = false;
      note.textContent = cards.length + ' fırsat listelendi · en yüksek indirim başta';
    }
  }

  /* ---- bar ---- */

  function buildBar(ctx, groups, usp) {
    const bar = document.createElement('div');
    bar.className = 'dv-deals-filters dv-df-v3';
    const sortActive = usp.get(SORT_PARAM) === SORT_VALUE;

    let anyActive = false;
    let groupsHtml = '';
    groups.forEach(g => {
      const activeVals = ctx.mode === 'collection' ? usp.getAll(g.param) : [];
      let current = null;
      let chips = '';
      g.items.forEach(it => {
        const on = activeVals.indexOf(it.v) !== -1;
        if (!on && it.c === 0) return; /* mevcut kombinasyonda 0 sonuçlu değeri gizle */
        if (on) { current = it; anyActive = true; }
        let dot = '';
        if (g.key === 'Renk') {
          const col = RENK_DOT[it.l.toLocaleLowerCase('tr-TR')];
          if (col) dot = '<span class="dv-df-dot" style="background:' + col + '"></span>';
        }
        chips += '<a class="dv-df-chip' + (on ? ' on' : '') + '" href="' + esc(hrefFor(ctx, g.param, it.v, on)) + '">'
          + dot + '<span>' + esc(it.l) + '</span>'
          + (it.c !== null && it.c !== undefined ? '<i>' + it.c + '</i>' : '')
          + (on ? '<b>✕</b>' : '')
          + '</a>';
      });
      groupsHtml +=
        '<details class="dv-df-group' + (current ? ' has-active' : '') + '">'
        + '<summary><span class="dv-df-gi">' + g.icon + '</span><span class="dv-df-gname">' + esc(g.key) + '</span>'
        + (current ? '<b class="dv-df-cur">' + esc(current.l) + '</b>' : '')
        + '<svg class="dv-df-chev" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M6 9l6 6 6-6"/></svg>'
        + '</summary>'
        + '<div class="dv-df-menu"><span class="dv-df-mtitle">' + esc(g.key) + ' seç</span>' + chips + '</div>'
        + '</details>';
    });

    let right = '';
    if (anyActive) {
      right += '<a class="dv-df-clear" href="' + BASE + '">✕ Filtreleri temizle</a>';
    }
    right += '<a class="dv-df-sort' + (sortActive ? ' on' : '') + '" href="' + esc(hrefSort(ctx, sortActive)) + '" title="Tüm fırsatları en yüksek indirime göre sırala">'
      + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M3 6h18M6 12h12M10 18h4"/></svg>'
      + '<u>En çok indirim</u>' + (sortActive ? '<b>✓</b>' : '') + '</a>';
    if (ctx.mode === 'index') {
      right += '<a class="dv-df-all" href="' + BASE + '">Tüm Fırsatları Gör <span aria-hidden="true">→</span></a>';
    }

    bar.innerHTML =
      '<div class="dv-df-row">'
      + '<span class="dv-df-title"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M22 3H2l8 9.46V19l4 2v-8.54z"/></svg>Filtrele</span>'
      + '<div class="dv-df-groups">' + groupsHtml + '</div>'
      + '<div class="dv-df-right">' + right + '</div>'
      + '</div>'
      + '<div class="dv-df-note" hidden></div>';

    /* yerleşim */
    if (ctx.mode === 'index') {
      const container = ctx.section.querySelector('.hdt-container') || ctx.section;
      const head = container.querySelector('.hdt-section-head');
      if (head) head.insertAdjacentElement('afterend', bar);
      else container.insertBefore(bar, container.firstChild);
    } else {
      const title = document.querySelector('.hdt-heading-full-page');
      const grid = findGrid();
      if (title && title.parentNode) title.parentNode.insertBefore(bar, title.nextSibling);
      else if (grid && grid.parentNode) grid.parentNode.insertBefore(bar, grid);
      else return null;
    }

    /* tek açık menü + dışarı tıklayınca kapat */
    const detailsList = Array.from(bar.querySelectorAll('.dv-df-group'));
    detailsList.forEach(d => {
      d.addEventListener('toggle', () => {
        if (d.open) detailsList.forEach(o => { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', e => {
      if (!bar.contains(e.target)) detailsList.forEach(o => { o.open = false; });
    });

    return bar;
  }

  /* ---- init ---- */

  async function init() {
    const ctx = getContext();
    if (!ctx || document.querySelector('.dv-deals-filters')) return;
    try {
      const groups = await loadGroups(ctx);
      const usp = new URLSearchParams(window.location.search);
      const bar = buildBar(ctx, groups || [], usp);
      if (bar && ctx.mode === 'collection' && usp.get(SORT_PARAM) === SORT_VALUE) {
        runGlobalSort(bar);
      }
    } catch (_) {
      /* veri yoksa filtre çizilmez */
    }
  }

/*DV_INP_DEALS_FILTER_NEAR_VIEW_20260730*/function scheduleInit(){const ctx=getContext();if(!ctx||ctx.mode!=="index"||!ctx.section){init();return}if(!("IntersectionObserver"in window)){setTimeout(init,5e3);return}const observer=new IntersectionObserver(entries=>{if(!entries.some(entry=>entry.isIntersecting))return;observer.disconnect();const run=()=>init();"requestIdleCallback"in window?requestIdleCallback(run,{timeout:1e3}):setTimeout(run,0)},{rootMargin:"200px 0px"});observer.observe(ctx.section)}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",scheduleInit,{once:!0}):scheduleInit()
})();
